import React from 'react';
import MatQuiz from './MatQuiz';
import './matquiz.css';

function Homework4MatQuiz() {
  return (
    <div className="quiz-wrapper">
      <h1>Math Quiz</h1>
      <MatQuiz />
    </div>
  );
}

export default Homework4MatQuiz;
